import { useMemo } from 'react';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { TaxRate } from '@mews-commander/data-access';
import { useGlobalizationResultQuery } from './useGlobalizationResultQuery';
import { useCurrentEnterpriseTaxCodes } from './useCurrentEnterpriseTaxCodes';

type TaxRateWithNonEmptyCode = Omit<TaxRate, 'code'> & { code: NonNullable<TaxRate['code']> };
const hasNonEmptyTaxRate = (taxRate: TaxRate): taxRate is TaxRateWithNonEmptyCode => !!taxRate.code;

export const useCurrentEnterpriseTaxRateCodes = () => {
    const { data } = useGlobalizationResultQuery();
    const taxationCodes = useCurrentEnterpriseTaxCodes();

    return useMemo(() => {
        const taxRates = data?.taxRates || [];
        if (array.isEmpty(taxationCodes) || array.isEmpty(taxRates)) {
            return [];
        }

        return pipe(
            taxRates,
            array.filter(
                (taxRate) => !!taxRate && taxationCodes.some((taxationCode) => taxationCode === taxRate.taxationCode)
            ),
            array.filter(hasNonEmptyTaxRate)
        );
    }, [data?.taxRates, taxationCodes]);
};
